import React, { useState } from "react";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import CallIcon from "@mui/icons-material/Call";

const ControlledSpeedDial = () => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const whatsAppUrl =
    "https://api.whatsapp.com/send/?phone=919928263305&text=Shree Mangalam School%21&type=phone_number&app_absent=0";
  // Define the actions for the SpeedDial
  const actions = [
    {
      icon: <WhatsAppIcon sx={{ color: "#AD1C86" }} />,
      name: "WhatsApp",
      onClick: () => window.open(whatsAppUrl), 
    },
    {
      icon: <CallIcon sx={{ color: "#AD1C86" }} />,
      name: "Call",
      onClick: () => window.open("tel:+919928263305"),  
    },
  ];

  return (
    <SpeedDial
      ariaLabel="Controlled SpeedDial"
      sx={{ position: "fixed", bottom: 16, left: 16 }}
      icon={<SpeedDialIcon />}
      FabProps={{
        sx: {
          bgcolor: "#AD1C86",
          color: "#fff",

          "&:hover": {
            bgcolor: "#8F146E",
          },
        },
      }}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {actions.map((action) => (
        <SpeedDialAction
          key={action.name}
          icon={action.icon}
          tooltipTitle={action.name}
          onClick={() => {
            action.onClick();
            handleClose();
          }}
        />
      ))}
    </SpeedDial>
  );
};

export default ControlledSpeedDial;
